import React from "react";

function ReassignQueues() {
  return <div>ReassignQueues</div>;
}

export default ReassignQueues;
